import styled from 'styled-components';
import PropTypes from 'prop-types';

import Time from 'components/Time';
import Toggler from 'components/Toggler';
import DropdownItem from 'components/DropdownItem';

import { getThemeProp } from 'theme';

export const StyledName = styled.div`
  align-items: center;
  display: inline-flex;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  margin: 0;
  text-align: left;
  width: 50%;
  flex: 1;
`;

export const StyledContainer = styled.div`
  align-items: center;
  background-color: ${getThemeProp('colors.white')};
  border: 1px solid ${getThemeProp('colors.ironGrey')};
  border-radius: 4px;
  display: flex;
  font-size: 0.76em;
  height: 81px;
  margin-bottom: 1rem;
  padding: 15px 25px;
  position: relative;
  text-align: center;

  &:hover {
    box-shadow: 0 3px 8px 0 rgba(186, 186, 186, 0.5);
  }

  && {
    .dropdown__content {
      margin-top: -16px;
      margin-right: 19px;
      width: max-content;
    }

    .toggler-wrapper {
      width: 100%;
    }
  }

  ${StyledName} {
    color: ${props =>
      props.hasIssues
        ? props.theme.colors.carnationRed
        : props.theme.colors.oxfordBlue};
  }
`;

StyledContainer.propTypes = {
  hasIssues: PropTypes.bool.isRequired,
};

export const StyledTime = styled(Time)`
  font-size: 12px;
  font-weight: 300;
  line-height: 1;
  margin: 0;
  width: 50%;
`;

export const StyledIconOptions = styled.i.attrs(() => ({
  className: 'icon-options',
  'data-test': 'dropdown-options-button',
}))`
  font-size: 16px;
  color: ${getThemeProp('colors.grey')};
  display: flex;
  align-items: center;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  justify-content: center;

  & {
    cursor: pointer;
  }

  &:hover {
    background-color: ${getThemeProp('colors.concreteGrey')};
  }
`;

export const StyledToggler = styled(Toggler)`
  line-height: inherit;

  &&& {
    cursor: pointer;
    justify-content: space-between;

    //target Toggler child with class label___xxxxx
    > *[class^='label'] {
      margin-right: 15px;
    }
  }
`;

export const StyledDropdownItem = styled(DropdownItem)`
  & {
    &&:hover {
      background-color: ${getThemeProp('colors.dodgerBlue')};
      color: ${getThemeProp('colors.white')};

      //target Toggler child with class label___xxxxx
      ${StyledToggler} {
        > *[class^='label'] {
          color: ${getThemeProp('colors.white')};
        }
      }
    }
  }
`;
